import moment from "moment";
import React, { useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';

import './Input.scss';

type DayBoundary = 'day' | 'week' | 'isoWeek' | 'month' | 'year' | 'hour' | 'minute';

interface DateInputProps {
    onChange: (value: string) => void;
    onBlur?: (value: string) => void;
    placeholder?: string;
    label?: string;
    value: string;
    disabled?: boolean;
    hasError?: boolean;
    errorLabel?: string;
    min?: string;
    max?: string;
    dateFormat?: string;
    startOf?: DayBoundary;
    endOf?: DayBoundary;
}

registerLocale('es', es);

const DateInput = React.forwardRef((props: DateInputProps, _ref: React.Ref<HTMLDivElement>) => {
    const [active, setActive] = useState(false);

    const activate = () => setActive(true);
    const deactivate = () => {
        setActive(false);
        if (props.onBlur) {
            props.onBlur(props.value);
        }
    };

    const normalizeBoundary = (date: Date): Date => {
        if (props.startOf) {
            return moment(date).startOf(props.startOf).toDate();
        }
        if (props.endOf) {
            return moment(date).endOf(props.endOf).toDate();
        }
        return date;
    };

    const onSelectDate = (date: Date) => {
        if (!date) {
            return;
        }
        props.onChange(normalizeBoundary(date).toJSON());
    };

    const selectedDate = props.value ? new Date(props.value) : null;
    const minDate = props.min ? new Date(props.min) : undefined;
    const maxDate = props.max ? new Date(props.max) : undefined;

    return (
        <div className={`inputBlock dateType ${active ? 'active' : ''} ${props.disabled ? 'disabled' : ''} ${props.value ? 'dirty' : ''} ${props.hasError ? 'error' : ''}`}>
            {props.label ? <label>{props.label}</label> : <label></label>}
            <div className={`inputWrapper date ${props.disabled ? 'disabled' : ''} ${active ? 'active' : ''} ${props.hasError ? 'error' : ''}`}>
                <DatePicker
                    selected={selectedDate}
                    onChange={onSelectDate}
                    onFocus={activate}
                    onBlur={deactivate}
                    minDate={minDate}
                    maxDate={maxDate}
                    placeholderText={props.placeholder || ''}
                    disabled={!!props.disabled}
                    className="input-date"
                    dateFormat={props.dateFormat || 'dd MMMM yyyy'}
                    locale="es"
                />
            </div>
            <div className="errorText">
                {props.hasError ? <span className="errorText">{props.errorLabel}</span> : ''}
            </div>
        </div>
    );
});

export default DateInput;
